import { hasInsights } from '@/common/app/modules/media/shareOfVoice'
import { ShareOfVoiceResult } from '@/common/model/media/shareOfVoice'


import GeoSection from '@/components/container/modules/mediaGeo/common/GeoSection'

import ShareOfVoiceInsightsPanel from './ShareOfVoiceInsightsPanel'
import ShareOfVoicePromptTable from './ShareOfVoicePromptTable'
import ShareOfVoiceShareChart from './ShareOfVoiceShareChart'
import ShareOfVoiceSummaryTable from './ShareOfVoiceSummaryTable'

interface Props {
  result: ShareOfVoiceResult
}

// シェア・オブ・ボイス分析の結果ビュー全体
const ShareOfVoiceResultView = ({ result }: Props) => {
  // 自社ブランドはシェアチャートの先頭（バックエンド側で自社→競合の順に並べている）
  const ownBrand = result.overall_share_chart?.[0]?.brand

  return (
    <div className='flex flex-col'>
      {/* シェア率のドーナツグラフとブランド別指標を横並びで示す */}
      <GeoSection title='ブランド別シェア・オブ・ボイス' noPadding>
        <div className='grid grid-cols-1 lg:grid-cols-2'>
          <div className='p-4'>
            <ShareOfVoiceShareChart overallShareChart={result.overall_share_chart ?? []} />
          </div>
          <ShareOfVoiceSummaryTable shareSummary={result.share_summary ?? {}} />
        </div>
      </GeoSection>

      <ShareOfVoicePromptTable prompts={result.prompts ?? []} ownBrand={ownBrand} />

      {hasInsights(result.insights) && result.insights && (
        <ShareOfVoiceInsightsPanel insights={result.insights} />
      )}
    </div>
  )
}

export default ShareOfVoiceResultView
